import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';

import {bindDispatch} from 'app/utils/redux';

import {ChangePasswordView} from 'dk-ui-lib';

const ChangePasswordContainer = (props) => {
  let {profile, actions} = props;
  let {updateOldPassword, updateNewPassword, updateConfirmNewPassword, changePassword} = actions;

  return (
    <div className='mx3 my3 flex justify-center container'>
      <ChangePasswordView
        profile={profile}
        updateOldPassword={updateOldPassword}
        updateNewPassword={updateNewPassword}
        updateConfirmNewPassword={updateConfirmNewPassword}
        changePassword={changePassword}
      />
    </div>
  );
}

const selector = createSelector(
  state => state.profile,
  (profile) => ({ profile })
);

ChangePasswordContainer.propTypes = {
  profile: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default connect(selector, bindDispatch)(ChangePasswordContainer);



// WEBPACK FOOTER //
// ./src/containers/profile/ChangePasswordContainer.js